import styled from "@emotion/styled";
import { Tabs } from "react-ui";
import { css } from "@emotion/react";

export const tabsMarginFix = css({
    marginLeft: 0,
});

export const PanelTab = styled(Tabs.Tab)({
    fontSize: "16px",
    marginRight: 10,
    marginLeft: 8,
});

export const PanelTabContent = styled("div")({
    display: "inline-flex",
    alignItems: "center",
});
